const faqs = [
  {
    q: '桃花影院真的完全免费吗？需要注册会员吗？',
    a: '是的，桃花影院完全免费，无需注册、无需登录、无需购买任何会员即可畅享所有影视内容。我们通过广告投放维持运营成本，绝不会向用户收取任何费用。打开网站就能直接看，就是这么简单。',
  },
  {
    q: '播放视频会不会卡顿？画质如何？',
    a: '桃花影院采用多线CDN加速与智能码率自适应技术，根据您的网络环境自动匹配最佳画质。主流宽带与4G/5G网络下均可流畅播放高清内容，极少出现缓冲现象。我们持续优化服务器节点，确保观影体验顺畅无阻。',
  },
  {
    q: '支持哪些设备观看？手机上可以看吗？',
    a: '桃花影院全面适配电脑、平板和手机等多种设备。无需下载任何APP，通过浏览器访问即可直接观看。移动端经过专门优化，支持全屏播放、手势调节音量和亮度、倍速播放等功能，在手机上也能获得极佳的观影体验。',
  },
  {
    q: '影片更新频率怎么样？能看最新的剧吗？',
    a: '我们保持每日更新，与主流平台同步上线最新剧集和电影。热播剧集通常在播出后数小时内即可在桃花影院观看，热门电影也会在最快时间内上架。您可以在「热播榜单」和「精选推荐」版块找到最新内容。',
  },
  {
    q: '影片资源丰富吗？有哪些类型的影视内容？',
    a: '桃花影院拥有超过20000部影视资源，涵盖电影、电视剧、综艺、动画、纪录片等多种类型。电影频道覆盖动作、喜剧、爱情、科幻、恐怖、悬疑、动画等全品类；电视剧包括国产剧、韩剧、美剧、日剧、泰剧等。无论您喜欢什么类型，都能在这里找到心仪的内容。',
  },
  {
    q: '如果遇到播放问题或者想看的影片没有怎么办？',
    a: '如果遇到播放异常，建议先刷新页面或切换线路尝试。如果仍然无法解决，可以通过「联系我们」版块提交问题反馈，我们的技术团队会尽快处理。如果您想看的影片暂未收录，也欢迎通过投稿渠道告知我们，我们会优先安排上线。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          关于桃花影院，您想了解的都在这里
        </p>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-start gap-3">
                <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-sm font-bold flex-shrink-0 mt-0.5">
                  Q
                </span>
                <div className="flex-1">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2">
                    {faq.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}